import { useRecoilState } from "recoil";
import { dividaConsolidadaLiquida } from "../atom";

const useDividaConsolidadaLiquidaState = () => {
    return useRecoilState(dividaConsolidadaLiquida);
};

export default useDividaConsolidadaLiquidaState;